import { focarJanelaProjeto } from './nwModulosJanela';

const CHANNEL = 'ade-desktop-v1';

export type HistoricoImpressaoCrossPayload = {
  projeto: { nomeProduto: string; nomePeca: string };
  configuracao: { larguraTotal: number; comprimentoTotal: number; espessuraSerra: number };
  layoutConfig: Record<string, unknown>;
  pecas: { codigo: number; medida: number; quantidade: number }[];
};

export type MensagemCrossWindow =
  | { tipo: 'carregar-projeto'; id: string }
  | { tipo: 'carregar-historico'; item: HistoricoImpressaoCrossPayload };

function nwGetAll(): Array<{ focus?: () => void; window?: Window }> {
  try {
    const runtime = (window as unknown as { nw?: { Window?: { getAll?: () => unknown[] } } }).nw;
    return (runtime?.Window?.getAll?.() ?? []) as Array<{ focus?: () => void; window?: Window }>;
  } catch {
    return [];
  }
}

/** Destino preferido: janela `modulo=projeto`, depois janela principal. */
function encontrarJanelaDestinoProjeto(): { focus?: () => void; window?: Window } | null {
  const todas = nwGetAll();
  for (const janela of todas) {
    const href = janela.window?.location?.href ?? '';
    if (href.includes('modulo=projeto')) return janela;
  }
  for (const janela of todas) {
    const href = janela.window?.location?.href ?? '';
    if (!href.includes('modulo=')) return janela;
  }
  return null;
}

/** Envia pedido para a janela Projeto carregar um projeto do catálogo. */
export function enviarCarregarProjetoParaJanelaPrincipal(projetoId: string): void {
  const msg: MensagemCrossWindow = { tipo: 'carregar-projeto', id: projetoId };

  const destino = encontrarJanelaDestinoProjeto();
  if (destino) {
    try {
      destino.window?.postMessage(msg, '*');
    } catch {
      /* ignora */
    }
    destino.focus?.();
    return;
  }

  try {
    const bc = new BroadcastChannel(CHANNEL);
    bc.postMessage(msg);
    bc.close();
  } catch {
    /* ignora */
  }

  focarJanelaProjeto();
}

/** Envia item do Histórico de Impressões para a janela Projeto carregar no editor. */
export function enviarCarregarHistoricoParaJanelaProjeto(
  item: HistoricoImpressaoCrossPayload
): void {
  const msg: MensagemCrossWindow = { tipo: 'carregar-historico', item };

  const destino = encontrarJanelaDestinoProjeto();
  if (destino) {
    try {
      destino.window?.postMessage(msg, '*');
    } catch {
      /* ignora */
    }
    destino.focus?.();
    return;
  }

  try {
    const bc = new BroadcastChannel(CHANNEL);
    bc.postMessage(msg);
    bc.close();
  } catch {
    /* ignora */
  }

  focarJanelaProjeto();
}

/**
 * Janela principal ou janela filha `modulo=projeto`: escuta pedidos do Catálogo.
 */
export function escutarCarregarProjetoNaJanelaPrincipal(
  onCarregar: (projetoId: string) => void
): () => void {
  const tratar = (data: unknown) => {
    const m = data as MensagemCrossWindow;
    if (m?.tipo === 'carregar-projeto' && typeof m.id === 'string' && m.id) {
      onCarregar(m.id);
    }
  };

  const onWindowMessage = (e: MessageEvent) => tratar(e.data);
  window.addEventListener('message', onWindowMessage);

  let bc: BroadcastChannel | null = null;
  try {
    bc = new BroadcastChannel(CHANNEL);
    bc.onmessage = (e) => tratar(e.data);
  } catch {
    /* ignora */
  }

  return () => {
    window.removeEventListener('message', onWindowMessage);
    bc?.close();
  };
}

/** Janela principal ou `modulo=projeto`: recebe "Carregar" do Histórico em outra janela. */
export function escutarCarregarHistoricoNaJanelaProjeto(
  onCarregar: (item: HistoricoImpressaoCrossPayload) => void
): () => void {
  const tratar = (data: unknown) => {
    const m = data as MensagemCrossWindow;
    if (m?.tipo === 'carregar-historico' && m.item && typeof m.item === 'object') {
      onCarregar(m.item);
    }
  };

  const onWindowMessage = (e: MessageEvent) => tratar(e.data);
  window.addEventListener('message', onWindowMessage);

  let bc: BroadcastChannel | null = null;
  try {
    bc = new BroadcastChannel(CHANNEL);
    bc.onmessage = (e) => tratar(e.data);
  } catch {
    /* ignora */
  }

  return () => {
    window.removeEventListener('message', onWindowMessage);
    bc?.close();
  };
}
